import { clearTag, downloadTag } from "api/tags";

const actionApiConfig = {
  downloadTag,
  clearTag
};

export default actionApiConfig;